// Mirrors backend/Src/Core/ProPool.Domain/Enums/BadgeTrack.cs - order matters, values are serialized
// as plain integers (no JsonStringEnumConverter configured).
export enum BadgeTrack {
	MatchesPlayed,
	TournamentFirstPlace,
	TournamentSecondPlace,
	TournamentThirdPlace,
	WinStreak,
	CheckinStreak,
	Nachtbraker,
	Toerist,
	VasteKlant,
	VroegeVogel,
	EeuwigeRivaal
}

export interface BadgeProgress {
	track: BadgeTrack;
	tier: number;
	unlockedAt: string | null;
}

export const BadgeTrackLabels: Record<BadgeTrack, string> = {
	[BadgeTrack.MatchesPlayed]: 'Partijen gespeeld',
	[BadgeTrack.TournamentFirstPlace]: 'Toernooiwinnaar',
	[BadgeTrack.TournamentSecondPlace]: 'Toernooi 2e plaats',
	[BadgeTrack.TournamentThirdPlace]: 'Toernooi 3e plaats',
	[BadgeTrack.WinStreak]: 'Op Dreef',
	[BadgeTrack.CheckinStreak]: 'Vijf op een Rij',
	[BadgeTrack.Nachtbraker]: 'Nachtbraker',
	[BadgeTrack.Toerist]: 'Toerist',
	[BadgeTrack.VasteKlant]: 'Vaste Klant',
	[BadgeTrack.VroegeVogel]: 'Vroege Vogel',
	[BadgeTrack.EeuwigeRivaal]: 'Eeuwige Rivaal'
};

export const BadgeTrackIcons: Record<BadgeTrack, string> = {
	[BadgeTrack.MatchesPlayed]: 'trophy-outline',
	[BadgeTrack.TournamentFirstPlace]: 'medal-outline',
	[BadgeTrack.TournamentSecondPlace]: 'medal-outline',
	[BadgeTrack.TournamentThirdPlace]: 'medal-outline',
	[BadgeTrack.WinStreak]: 'flame-outline',
	[BadgeTrack.CheckinStreak]: 'calendar-outline',
	[BadgeTrack.Nachtbraker]: 'moon-outline',
	[BadgeTrack.Toerist]: 'compass-outline',
	[BadgeTrack.VasteKlant]: 'home-outline',
	[BadgeTrack.VroegeVogel]: 'sunny-outline',
	[BadgeTrack.EeuwigeRivaal]: 'skull-outline'
};
